import {
  $,
  IResource,
  Model,
  ResponseFill,
  HttpIgnore,
} from 'simpli-web-sdk'
import moment from 'moment'
import {ItrackCollection} from '@/helpers'

@HttpIgnore()
export default class DateFilterRequest extends Model {

  @ResponseFill()
  dia: number | null = null

  @ResponseFill()
  mes: number | null = moment().month() + 1

  @ResponseFill()
  ano: number | null = moment().year()

  monthCollection = ItrackCollection.getMonthCollection().prependNull('app.all')
  yearCollection = ItrackCollection.getYearCollection().prependNull('app.all')

  get momentFormat() {
    const m = moment()

    if (this.dia) {
      m.set('day', this.dia)
    }

    if (this.mes) {
      m.set('month', this.mes - 1)
    }

    if (this.ano) {
      m.set('year', this.ano)
    }

    return m.format()
  }

  get dayCollection() {
    return ItrackCollection.getDayCollection(this.momentFormat).prependNull('app.all')
  }

  get dayResource() {
    return this.dayCollection.get(this.dia)
  }
  set dayResource(val: IResource | null) {
    this.dia = val && val.$id as number || null
  }

  get monthResource() {
    return this.monthCollection.get(this.mes)
  }
  set monthResource(val: IResource | null) {
    this.mes = val && val.$id as number || null
  }

  get yearResource() {
    return this.yearCollection.get(this.ano)
  }
  set yearResource(val: IResource | null) {
    this.ano = val && val.$id as number || null
  }
}
